import React, { useEffect } from 'react'
import { getImages } from './const';

const VideoModal = ({ children, open, close, modalWidth, fadeIn, videoData }) => {
  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.keyCode === 27 && open) {
        close(); // Close the modal if Escape key is pressed and modal is open
      }
    };
    document.addEventListener('keydown', handleEscapeKey);
    return () => {
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [open, close]);
  console.log("videoData", videoData)
  const getEmbedUrl = (url) => {
    if (!url) return "";

    // If already embed, return it
    if (url.includes("embed")) return url;

    // For youtube.com/watch?v=
    if (url.includes("watch?v=")) {
        return url.replace("watch?v=", "embed/");
    }

    // For youtu.be short links
    if (url.includes("youtu.be")) {
        const videoId = url.split("youtu.be/")[1];
        return `https://www.youtube.com/embed/${videoId}`;
    }

    return url;
    };

  return (
    <>
      <div className={`"modal fade custom-modal video-modal ${fadeIn ? 'fadeIn' : ''} ${open ? "show" : ""}`} 
        id="commonModal" 
        data-bs-backdrop="static" 
        data-bs-keyboard="false" 
        tabIndex="-1" aria-labelledby="staticBackdropLabel" 
      >
      <div className={`overlay-modal cs-overflow-modal ${open ? "open" : ""}`} onClick={close}></div>
        <div className={`modal-dialog modal-dialog-centered`} style={{maxWidth: modalWidth}}>
            <div className="modal-content p-0">
                <div className="modal-body p-0">
                    <div className='modal-header'>
                        <div className='sm-title text-center text-uppercase w-100'>Mark Motors - Meet {videoData.full_name}</div>
                        <button className="sm-box-close pe-4" type="button" onClick={close}>
                            <img src={getImages('white-close.svg')} />
                        </button>
                    </div>
                     {videoData.video_link && (
                        <div className="vid-wrapper">
                            <iframe
                                width="100%"
                                height="600"
                                src={getEmbedUrl(videoData.video_link)}
                                title={videoData.full_name}
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            />
                            {/* <iframe width="100%" height="600" src="https://www.youtube.com/embed/87-yA2XYjrc?si=z7FVHfkjR2ieuPWZ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe> */}
                        </div>
                    )}
                </div>
            </div>
        </div>
      </div>
    </>
  )
}

export default VideoModal